import { createContext, useEffect, useState } from 'react';
import { Lang_Types, LocalStorage_keys } from '../constants';
import { localStorageService } from '../../infrastructure/services';
import { AuthenticatedUser } from '../../domain/users/authenticate-user';
import { LanguageResources } from '../../domain/language';
import {
    changeLanguageUseCase,
    setLanguageUseCase,
} from '../../application/language/use-cases';
import { ContextProps } from './contextProps';
import { ProviderProps } from './providerProps';
import { RouteListType } from '../../domain/shared/RoutesType';

export const AppContext = createContext({} as ContextProps);

export const AppProvider = ({ children }: ProviderProps) => {
    const [lang, setLang] = useState(
        localStorageService.get(LocalStorage_keys.LANG_KEY, false) ??
            Lang_Types['ES-CO']
    );

    const [langResources, setLangResources] = useState<LanguageResources>(
        {} as LanguageResources
    );

    const [selectedFlag, setSelectedFlag] = useState<string>('');

    const [nestedRoutes, setNestedRoutes] = useState<RouteListType>([]);

    const initialUser = localStorageService.get(LocalStorage_keys.USER_KEY, true);

    const [userInfo, setuserInfo] = useState<AuthenticatedUser>(
        initialUser ?? initialUser
    );

    const [isSkinSmart, setIsSkinSmart] = useState(
        process.env.REACT_APP_SKIN === 'smart'
    );

    const [appVersion, setAppVersion] = useState(
        process.env.REACT_APP_VERSION ?? ''
    );

    const [dispatchersIds, setDispatchersIds] = useState<number[]>([]);

    useEffect(() => {
        if (!isSkinSmart) {
            document.getElementById('root')?.setAttribute('class', 'skin_siesa');
        }
    }, [isSkinSmart]);

    useEffect(() => {
        setSelectedFlag(changeLanguageUseCase);
        setLangResources(setLanguageUseCase(lang));
    }, [lang]);

    return (
        <AppContext.Provider
            value={{
                lang,
                appVersion,
                isSkinSmart,
                langResources,
                selectedFlag,
                setLang,
                userInfo,
                dispatchersIds,
                nestedRoutes,
                setNestedRoutes,
            }}
        >
            {children}
        </AppContext.Provider>
    );
};
